import { render, staticRenderFns } from "./AdjustmentReasonTypeForm.vue?vue&type=template&id=21be757f&scoped=true"
import script from "./AdjustmentReasonTypeForm.vue?vue&type=script&lang=js"
export * from "./AdjustmentReasonTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be757f",
  null
  
)

export default component.exports